import React, { useEffect, useState } from 'react';
import './AnimatedText.scss';

interface AnimatedTextProps {
  text: string;
  className?: string;
  id?: string;
}

const AnimatedText: React.FC<AnimatedTextProps> = ({ id, text, className = '' }) => {
  const [currentText, setCurrentText] = useState(text);
  const [currentId, setCurrentId] = useState(id);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (id !== currentId) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setCurrentId(id);
        setCurrentText(text);
        setIsAnimating(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [text, id]);

  return (
    <div className={`animated-text ${className} ${isAnimating ? 'fade-out' : 'fade-in'}`}>
      {currentText}
    </div>
  );
};

export default AnimatedText; 